import PubSub from "underpub-js";

var AvailabilityTable = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-AvailabilityTable',
	};

	$.extend(true, this.options, options);

};

AvailabilityTable.prototype.init = function() {

	var self = this;

};

export default AvailabilityTable;
